"use strict";
/**
 * materialData：资料数据，只用到了 _id
 * type：C端资料类型：
 *    article：表示文章；
 *    form：表示表单；
 *    h5：表示H5；
 *    qrcode：企业活码；
 *    case：案例库；
 *    video：视频；
 *    poster：海报；
 *    brochure：宣传册；
 * projectScene：当前项目场景：
 *    mk：表示营销系统（默认）；qw：表示服务商后台；cof：朋友圈助手
 * isNoDev：是否不是dev环境
 * otherConfig：额外参数对象
 * _user：user对象
 *    默认为 null，表示从 localStorage 里面去拿
 *    为 对象时，表示使用传入的user，一般在 C端 项目里面才会传入
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMaterialUrl = exports.getAdIdParams = exports.createAdId = exports.getTargetDomain = exports.replaceUrl = exports.urlEncode = void 0;
const iutils_1 = require("@dustess/iutils");
const ajax_1 = require("./ajax");
/**
*
* @param {*要转为URL参数字符串的对象} param
* @param {*是否进行URL编码，默认为false} encode
* @param {*URL参数字符串的前缀} key
* @description 将对象转为url参数字符串
*/
const urlEncode = (param, encode, key) => {
    if (param == null)
        return '';
    let paramStr = '';
    const t = typeof param;
    if (['string', 'number', 'boolean'].includes(t)) {
        paramStr += `&${key}=${encode ? encodeURIComponent(param) : param}`;
    }
    else {
        Object.keys(param).forEach((i) => {
            const k = key ? key + (param instanceof Array ? `[${i}]` : `.${i}`) : i;
            paramStr += (0, exports.urlEncode)(param[i], encode, k);
        });
    }
    return paramStr;
};
exports.urlEncode = urlEncode;
/**
 * URL替换
 * @param url 需要替换的url
 * @param newDomain 新的域名
 * @returns
 */
function replaceUrl(url, newDomain) {
    const urlParts = /^(https?:\/\/)([^\/]+)(.*)$/.exec(url);
    if (urlParts && newDomain) {
        const protocol = urlParts[1];
        return protocol + newDomain + urlParts[3];
    }
    else {
        return url;
    }
}
exports.replaceUrl = replaceUrl;
/**
 * 获取目标域名
 * @param params
 * @returns
 * @address https://yapi.dustess.com/project/2088/interface/api/565132
 */
const getTargetDomain = async (params) => {
    const result = await (0, ajax_1.ajax)({
        url: '/material/center/v1/chains_tracing/share_url',
        method: 'POST',
        params,
    });
    const { code, success, data } = result;
    if (code === 500200 && success) {
        return data === null || data === void 0 ? void 0 : data.domain;
    }
    return '';
};
exports.getTargetDomain = getTargetDomain;
const createH5Url = async (materialData, type = 'article', projectScene = 'mk', isNoDev = true, otherParams = {}, _user = null) => {
    // 将传入的值转为小写的：主要是针对H5类型的，因为要兼容以前老的h5传入，又要处理现在新的C端传入的H5，所以就先直接转为小写的
    type = type.toLocaleLowerCase();
    type = type === 'case' ? 'article' : type;
    // VUE_APP_M_C_BASE_URL：微信端域名
    // VUE_APP_QW_SCRM_BASE_URL：企微端域名
    // VUE_APP_WXMINI_CONFIG_BASE_URL：小程序-H5端域名
    // VUE_APP_MK_MESH_BASE_URL：第三方应用域名
    const { VUE_APP_M_C_BASE_URL, VUE_APP_QW_SCRM_BASE_URL, VUE_APP_WXMINI_CONFIG_BASE_URL, VUE_APP_MK_MESH_BASE_URL } = window.envConfig || {};
    // 允许使用最新版逻辑的数据
    const canUseNewVersionList = ['mk', 'qw'];
    // 是否采用最新版的逻辑来生成h5方法
    let isUseNewVersionCreateH5Url = canUseNewVersionList.includes(projectScene);
    /**
    * !2020-4-17 16:12-企微1.0.3迁移版本更改-hzq
    *
    * 更改描述：营销、企微的上报路径将从今天开始不会区分开了，统一使用最新版本的
    *  1. 都走新的上报路径，并且有大量参数的更改，对应生成的C端链接上面必定会增加v3字段
    */
    /**
    * !是否为企微
    */
    const isQw = projectScene === 'qw';
    /**
    * 所有C端项目对应的配置
    */
    const defaultTypeConfig = {
        // 营销红包
        'marketingredpacket': {
            // 本地启动的端口，仅仅本地开发才用的
            port: '8104',
            // 项目的pathname
            pathname: `/mk-h5-operation/adredpacket.html`,
            // 地址参数对象：资料id参数
            params: {
                materialId: materialData.id || materialData._id,
                operateEntity: 'marketingRedPacket'
            }
        },
        article: {
            // 本地启动的端口，仅仅本地开发才用的
            port: '3001',
            // 项目的pathname
            pathname: `/mk-h5-content/#/article`,
            // 地址参数对象：资料id参数
            params: {
                artId: materialData.id || materialData._id
            }
        },
        // 表单
        form: {
            port: '3001',
            pathname: `/mk-h5-content/#/form`,
            params: {
                formId: materialData.id || materialData._id
            },
        },
        // h5
        h5: {
            port: '3001',
            pathname: `/mk-h5-content/#/h5`,
            params: {
                materialId: materialData.id || materialData._id
            }
        },
        // 活码中间页
        qrcode: {
            port: '8094',
            pathname: `/h5-qrcode/index.html`,
            params: {
                codeId: materialData.id || materialData._id
            }
        },
        // 案例库 这种类型合并到文章中了
        case: {
            port: '3001',
            pathname: `/mk-h5-content/#/article`,
            params: {
                materialId: materialData.id || materialData._id
            }
        },
        // 视频-普通素材、小程序素材
        video: {
            port: '3001',
            pathname: `/mk-h5-content/#/video`,
            params: {
                materialId: materialData.id || materialData._id,
                // !2020-03-25新增：当为【企业文件夹】时，额外新增operateEntity，用来表示【企业文件夹】，后面C端项目里面需要；正常的【营销资料】不需要该字段，因为在C端里面默认处理为【营销资料】
                // 线索实体-默认先使用miniMaterial值，当为commonMaterial类型时，就要自己在外面传入该值
                // 当前视频有两种实体：miniMaterial (小程序里面的小程序素材 - 视频) 、commonMaterial (小程序里面的普通素材 - 视频 - 目前不会上报，所以该参数传不传不影响使用)
                operateEntity: 'miniMaterial'
            }
        },
        // 海报
        poster: {
            port: '3001',
            pathname: `/mk-h5-content/#/poster`,
            params: {
                materialId: materialData.id || materialData._id
            }
        },
        // 宣传册
        brochure: {
            port: '3001',
            pathname: `/mk-h5-content/#/brochure`,
            params: {
                materialId: materialData.id || materialData._id
            }
        },
        // 营销视频
        'video-markting': {
            port: '3001',
            pathname: `/mk-h5-content/#/mk-video`,
            params: {
                materialId: materialData.id || materialData._id
            }
        },
        // 任意连接
        link: {
            port: '3001',
            pathname: `/mk-h5-content/#/link`,
            params: {
                materialId: materialData.id || materialData._id
            }
        },
        // 文件预览
        preview: {
            port: '8100',
            pathname: `/h5-preview/index.html`,
            params: {
                materialId: materialData.id || materialData._id
            },
            // 配置：链接上面不想要带的参数
            ignoreParams: [
                'userid',
                'materialType',
                'accountName',
                'corpId',
                'qwUid',
                'qwUserId',
                'agentId',
                'sid',
                'scene',
                'version'
            ]
        },
        // 热门好文
        'hot-article': {
            // 本地启动的端口，仅仅本地开发才用的
            port: '8101',
            // 项目的pathname
            pathname: `/h5-article/hot-article/index.html`,
            // 地址参数对象：资料id参数
            params: {
                materialId: materialData._id,
                operateEntity: 'hotMaterial'
            }
        },
        // 微信支付-红包项目
        wxpay: {
            // 本地启动的端口，仅仅本地开发才用的
            port: '9001',
            // port: '8102',
            // 项目的pathname
            pathname: '/qw-mobile-reach-h5-web/red-envelope.html',
            // 地址参数对象：资料id参数
            params: {
                materialId: materialData._id,
                operateEntity: 'redPacket'
            }
        },
        // 营销工具-抽奖
        'marketinglottery': {
            port: '8090',
            // 项目的pathname
            pathname: `/mk-activities/#/pages/lottery/index`,
            // 地址参数对象：资料id参数
            params: {
                materialId: materialData._id,
                lotteryDetailsId: materialData._id,
                account: materialData.account,
                uid: materialData.uid,
                operateEntity: 'marketinglottery'
            }
        },
        // 营销裂变
        marketingfission: {
            port: '8090',
            // 项目的pathname
            pathname: `/mk-activities/#/pages/fission/index`,
            // 地址参数对象：资料id参数
            params: {
                eventId: materialData.eventId,
                account: materialData.account,
                uid: materialData.uid,
                operateEntity: 'marketingFission'
            }
        },
        // 企业文件
        ordinaryfile: {
            port: '3001',
            pathname: `/mk-h5-content/#/ordinary-file`,
            params: {
                id: materialData.id || materialData._id
            },
            // 配置：链接上面不想要带的参数
            ignoreParams: [
                'userid',
                'materialType',
                'accountName',
                'qwUserId',
                'scene',
                'version',
                'project'
            ]
        }
    };
    let config = defaultTypeConfig[type];
    // 处理C端访问域名
    let url = VUE_APP_M_C_BASE_URL;
    if (isQw) {
        url = VUE_APP_QW_SCRM_BASE_URL;
    }
    // 当生成小程序的H5预览地址时
    if (otherParams.isMini) {
        url = VUE_APP_WXMINI_CONFIG_BASE_URL;
    }
    // 地址参数对象
    let { params } = config;
    // user对象对应在localStorage里面的key
    const userKeyMap = {
        mk: 'user',
        qw: {
            default: 'qw-user',
            third: 'user'
        },
        cof: 'cof-user'
    };
    let localStorageUserKey = userKeyMap[projectScene];
    if (typeof localStorageUserKey === 'object') {
        const projectSecondScene = otherParams.projectSecondScene || 'default';
        localStorageUserKey = localStorageUserKey[projectSecondScene];
        // 当为第三方的H5预览地址时
        if (projectSecondScene === 'third') {
            url = VUE_APP_MK_MESH_BASE_URL;
            otherParams.noCorpIdInUrl = true;
        }
    }
    const user = _user || JSON.parse(window.localStorage.getItem(localStorageUserKey)) || null;
    if (!user) {
        // eslint-disable-next-line
        console.error('createH5Url方法内报错：user数据获取失败');
        return { linkUrl: '', qrcodeUrl: '' };
    }
    // !C端参数详细说明：https://git.dustess.com/markting/biz/mk-client/issues/37
    // 地址参数对象：加上 id
    params.userid = user.id;
    // 地址参数对象：加上 account
    params.account = user.account;
    // 地址参数对象：加上 accountName
    params.accountName = '';
    if (isQw) {
        // 企业微信跳转到C端时，需要下面的参数
        const { corpName, accountName, corpId, uid, agentId, sid, qwUserId } = user;
        params.accountName = corpName || accountName;
        params.corpId = corpId;
        params.qwUid = uid;
        params.qwUserId = qwUserId;
        params.agentId = agentId;
        params.sid = sid;
        // 当为 企微时，需要将 corpId 拼接到 https:// 后面
        /**
         * noCorpIdInUrl：链接上面是否需要拼接corpId
         * true：明确表明不用拼接corpId
         * 不为true（false，undefined等等）：表明需要拼接corpId
         */
        if (otherParams.noCorpIdInUrl !== true) {
            const affix = (0, iutils_1.getDomainAffix)();
            url = affix ? url.replace('//', `//${affix}-`) : url;
        }
        // 当为第三方的H5预览地址时
        if (otherParams.projectSecondScene === 'third') {
            params.suiteId = user.suiteId || '';
        }
    }
    else {
        // 营销系统跳转到C端时，需要下面的参数
        params.accountName = user.accountName;
    }
    // 当为C端访问时，直接拿location.origin作为url
    if (otherParams.client === 'c-client') {
        url = location.origin;
    }
    if (!isNoDev) {
        url = location.origin.replace(location.port, config.port);
    }
    // 将公司名称中文转为encodeURIComponent
    params.accountName = encodeURIComponent(params.accountName);
    // 链接上新增materialType字段
    params.materialType = type === 'h5' ? 'H5' : type;
    // 当为 最新版 时，新的链接上面需要增加version字段，现在的值为v3
    if (isUseNewVersionCreateH5Url)
        params.version = 'v3';
    // 将其他传入的参数加到 地址参数对象上
    params = Object.assign(Object.assign({}, params), otherParams);
    // 删除多余参数的（所有链接都要删除的）---------------
    // 目前需要删除4个
    delete params.noCorpIdInUrl;
    delete params.isMini;
    delete params.sid;
    delete params.client;
    if (params.accountName !== 'chenfeng')
        delete params.accountName;
    if (params.projectSecondScene === 'default' || !params.projectSecondScene)
        delete params.accountName;
    // 删除多余参数的---------------
    /**
     * C端链接要加上项目场景
     * 目前情况：
     *    1、cof 场景下的 C端项目里面的 上报接口路径会更改；
     *    2、其他场景暂未有更改
     */
    // 地址参数对象：加上project参数
    const project = projectScene;
    /**
     * !C端资料对应的分享场景
     * !2020-03-25更改：
     *  !1. 需要区别企微和营销，因为后端上报接口路径已经开始区分企微和营销了，所以前端也必须对场景值做区分
     */
    const shareSceneCodeMap = {
        // mk：代表营销类型
        // 【营销】分享场景具体yapi说明：https://yapi.dustess.com/project/26/interface/api/23704
        v3: {
            article: 2001,
            'hot-article': 2001,
            form: 2002,
            h5: 2003,
            case: 2004,
            brochure: 2005,
            video: 2006,
            'video-markting': 2010,
            'marketingredpacket': 2014,
            'marketinglottery': 2015,
        },
        // mk：代表不是营销类型，比如：企微、朋友圈助手
        // 这些分享场景具体yapi说明：https://yapi.dustess.com/project/26/interface/api/1988
        default: {
            article: 20,
            form: 21,
            h5: 22,
            qrcode: 23,
            case: 24,
            video: 25,
            poster: 26,
            brochure: 27,
            'marketingredpacket': 28,
            'marketinglottery': 29
        }
    };
    // 当前项目场景对应的分享场景
    const currProjectShareSceneMap = shareSceneCodeMap[params.version] || shareSceneCodeMap.default;
    // 最终生成的分享场景，当未匹配到场景时，采用 9999 来赋值
    let shareScene = currProjectShareSceneMap[type] || 9999;
    // 二维码对应的分享场景-默认使用 营销 场景的值
    let qrcodeUrlShareScene = shareScene;
    // 链接对应的分享场景-默认使用 营销 场景的值
    let linkUrlShareScene = shareScene;
    if (!isUseNewVersionCreateH5Url) {
        // !当不为新版本时，还分别需要在二维码、链接对应的场景后面再拼接字符串，用于真正区分二维码、链接
        // 01：表示二维码
        qrcodeUrlShareScene = shareScene + '01';
        // 02：表示链接
        linkUrlShareScene = shareScene + '02';
    }
    const qrcodeParams = Object.assign(Object.assign({}, params), { scene: qrcodeUrlShareScene });
    const linkParams = Object.assign(Object.assign({}, params), { scene: linkUrlShareScene });
    // 根据 ignoreParams 值，来动态删除多余参数
    if (config.ignoreParams && config.ignoreParams.length) {
        config.ignoreParams.forEach((item) => {
            delete qrcodeParams[item];
            delete linkParams[item];
        });
    }
    // 将参数对象转为url字符串
    const qrcodeParamsUrl = (0, exports.urlEncode)(qrcodeParams).replace('&', '?');
    const linkParamsUrl = (0, exports.urlEncode)(linkParams).replace('&', '?');
    // 地址拼接
    url += config.pathname;
    /**
     * 当 C 端资料链接 最后一项参数为对应的分享场景时
     * 在场景 活码二维码：2301 下 ，使用微信浏览器访问 该活码二维码 会偶现 空白页，无法加载内容
     * 所以需要将项目场景 project 拼接至最后，使活码二维码：2301并非最后一个参数，避免该bug
     */
    // 01：表示二维码
    const qrcodeUrl = `${url + qrcodeParamsUrl}&project=${project}`;
    // 02：表示链接
    const linkUrl = `${url + linkParamsUrl}&project=${project}`;
    // 获取目标域名
    const targetDomain = await (0, exports.getTargetDomain)({ account: user === null || user === void 0 ? void 0 : user.account, isGetMiniURL: Boolean(otherParams === null || otherParams === void 0 ? void 0 : otherParams.noCorpIdInUrl) });
    return {
        qrcodeUrl: targetDomain ? replaceUrl(qrcodeUrl, targetDomain) : qrcodeUrl,
        linkUrl: targetDomain ? replaceUrl(linkUrl, targetDomain) : linkUrl,
        linkParams,
        targetUrl: targetDomain ? replaceUrl(url, targetDomain) : url,
        project,
        user
    };
};
exports.default = createH5Url;
/**
 * 创建adId
 * @param params
 * @returns
 * @address https://yapi.dustess.com/project/2088/interface/api/565126
 */
const createAdId = (params) => (0, ajax_1.ajax)({
    url: '/material/center/v1/chains_tracing/ad_id',
    method: 'POST',
    params,
});
exports.createAdId = createAdId;
/**
 * 获取adId对应的参数
 * @param params 请求参数
 * @returns
 */
const getAdIdParams = (params) => (0, ajax_1.ajax)({
    url: '/material/center/v1/chains_tracing/ad_id',
    method: 'GET',
    params
});
exports.getAdIdParams = getAdIdParams;
/**
 * 生成素材预览页地址
 * @param materialData 素材详情数据
 * @param type 素材类型
 * @param projectScene 场景值 'qw'
 * @param isNoDev 是否不是开发环境
 * @param otherParams 额外参数
 * @param _user 用户信息
 * @param sceneType 投放类型
 * @returns
 */
const createMaterialUrl = async (materialData, type = 'article', projectScene = 'mk', isNoDev = true, otherParams = {}, _user = null, sceneType = 'conver-params') => {
    const { qrcodeUrl, linkParams, targetUrl, project, user } = await createH5Url(materialData, type, projectScene, isNoDev, otherParams, _user);
    //过滤空参数
    const targetParams = linkParams;
    for (const key in targetParams) {
        if (targetParams.hasOwnProperty(key) && (targetParams[key] === null || targetParams[key] === undefined || targetParams[key] === '')) {
            delete targetParams[key];
        }
    }
    // 如果传入的参数中存在adId则需要删除
    if (targetParams === null || targetParams === void 0 ? void 0 : targetParams.adId) {
        delete targetParams.adId;
    }
    // 生成ad_Id
    const { success, data } = await (0, exports.createAdId)({
        account: user === null || user === void 0 ? void 0 : user.account,
        extraData: Object.assign(Object.assign({}, targetParams), { project }),
        sceneType,
        url: targetUrl
    });
    return {
        qrcodeUrl,
        adId: success ? data === null || data === void 0 ? void 0 : data.adId : '',
        linkUrl: success ? `${data === null || data === void 0 ? void 0 : data.url}&account=${user === null || user === void 0 ? void 0 : user.account}` : '' // 必须保证链接上存在account
    };
};
exports.createMaterialUrl = createMaterialUrl;
//# sourceMappingURL=index.js.map